exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-pagination {\n  height: 30px;\n  min-width: 50px; }\n\n.m-page-selector {\n  font-size: 16px;\n  text-align: center;\n  background: #ffffff;\n  color: #848484;\n  height: 30px;\n  min-width: 50px;\n  border: 0 none;\n  outline: 0; }\n\n.pagination-height {\n  height: 30px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/modules/mobile/components/pagination-control/m-pagination-control.component.scss
// module id = ../../../../../angular/app/modules/mobile/components/pagination-control/m-pagination-control.component.scss
// module chunks = main